export default __webpack_public_path__ + "static/media/new-qr.6bdce718.png";